import * as React from 'react';
// import Toggle from '../../../common/form/Toggle';
import FormSelectLabeled from '../../../common/form/SelectLabeled';
import { availableTimeslots } from '../../../../utilities/timeslots';
import { TourInterval } from '../../../../api/Property';
// import CheckboxLabeled from '../../../common/form/CheckboxLabeled';

interface State {
    storedStartTime: string;
    storedEndTime: string;
}

interface Props {
    interval: TourInterval;
    intervalName: string;
    dayName: string;
    defaultStart: string;
    defaultEnd: string;
    onChange: (newValue: TourInterval) => void;
    isDisabled: boolean; 
}

class TourOfficeOpenConfigSection extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            storedStartTime: this.props.interval.propertyHoursStartTime,
            storedEndTime: this.props.interval.propertyHoursEndTime
        };

        this.handleChange = this.handleChange.bind(this);
        
    }

    render() {
        let startTime = this.props.interval && this.props.interval.propertyHoursStartTime;
        let endTime = this.props.interval && this.props.interval.propertyHoursEndTime;
        // let blockedStartTime = this.props.interval && this.props.interval.blockedStartTime;
        // let blockedEndTime = this.props.interval && this.props.interval.blockedEndTime;
        let timeSelectOptions = availableTimeslots.map(slot => ({
            value: slot,
            label: slot
        }));
        let idPrefix = `${this.props.dayName}-${this.props.intervalName}`;

        const handleRadioClick = (answer:boolean) => {
            if(answer) {
                this.setState({
                    storedStartTime: startTime!,
                    storedEndTime: endTime!
                });                                    
                this.props.onChange({
                    ...this.props.interval,
                    propertyHoursOpen: true
                });
            } else {
                this.props.onChange({
                    ...this.props.interval,
                    propertyHoursOpen: false
                });
            }
        };

        return (
            <>
                <div className="row">
                <div className="col-6 font-weight-bold">Leasing Office Open</div>
                    <div className="col-6 tour-config-section-yes-no-toggle-wrapper" style={{display:'flex', alignItems:'center', marginBottom:'15px'}}>
                        <div className="custom-radio-wrapper">
                            <div                                
                                className="custom-radio-circle"
                                onClick={() => handleRadioClick(true)}
                                style={{ pointerEvents: this.props.isDisabled ? 'none' : 'auto' }}
                            >   
                                {this.props.interval.propertyHoursOpen &&
                                    <div className="custom-radio-selected"/>                                                                    
                                }
                            </div>
                            <div className="custom-radio-label">Yes</div>
                            <div
                                className="custom-radio-circle"  
                                onClick={() => handleRadioClick(false)}  
                                style={{ pointerEvents: this.props.isDisabled ? 'none' : 'auto' }}                        
                            >   
                                {!this.props.interval.propertyHoursOpen &&
                                    <div className="custom-radio-selected"/>                                
                                    
                                }
                            </div>
                            <div className="custom-radio-label">No</div>     
                        </div>  
                    </div>
                </div>     
                    <>
                        <div className="form-group row">
                            <FormSelectLabeled
                                labelProps={{
                                    labelText: 'Start'
                                }}
                                selectProps={{
                                    id: `${idPrefix}-office-start-time`,
                                    name: 'propertyHoursStartTime',
                                    value: startTime,  
                                    placeholder:'Select An Hour',
                                    disabled: this.props.interval.propertyHoursOpen === false || this.props.isDisabled 
                               
                                }}
                                selectOptions={timeSelectOptions}
                                onChange={this.handleChange}
                                className="col-6"
                            />
                            <FormSelectLabeled
                                labelProps={{
                                    labelText: 'End'
                                }}
                                selectProps={{
                                    id: `${idPrefix}-office-end-time`,
                                    name: 'propertyHoursEndTime',
                                    value: endTime,  
                                    placeholder:'Select An Hour',
                                    disabled: this.props.interval.propertyHoursOpen === false || this.props.isDisabled 
                                                                
                                }}
                                selectOptions={timeSelectOptions}
                                onChange={this.handleChange}
                                className="col-6"
                            />
                        </div>
                        {/* <CheckboxLabeled
                            labelProps={{
                                labelText: 'Disable tours for window during time range?'
                            }}
                            inputProps={{
                                name: 'disabledWindowCheckbox',
                                id: `${idPrefix}-tours-disabled-checkbox`,
                                checked: this.props.interval.blockedTimeEnabled
                            }}
                            onChange={(inputName, newValue) =>
                                this.props.onChange({
                                    ...this.props.interval,
                                    blockedTimeEnabled: newValue
                                })
                            }
                            controlCssClass="small-inline-label"
                        />
                        {this.props.interval.blockedTimeEnabled && (
                            <div className="form-group row">
                                <FormSelectLabeled
                                    labelProps={{
                                        labelText: 'Disable Tours From...'
                                    }}
                                    selectProps={{
                                        id: `${idPrefix}-tour-blocked-start-time`,
                                        name: 'blockedStartTime',
                                        value: blockedStartTime
                                    }}
                                    selectOptions={timeSelectOptions}
                                    onChange={this.handleChange}
                                    className="col-6"
                                />
                                <FormSelectLabeled
                                    labelProps={{
                                        labelText: '...To'
                                    }}
                                    selectProps={{
                                        id: `${idPrefix}-tour-blocked-end-time`,
                                        name: 'blockedEndTime',
                                        value: blockedEndTime
                                    }}
                                    selectOptions={timeSelectOptions}
                                    onChange={this.handleChange}
                                    className="col-6"
                                />
                            </div>
                        )} */}
                    </>
              </>
        );
    }

    handleChange(name: string, value: any) {
        this.props.onChange({ ...this.props.interval, [name]: value });
    }
}

export default TourOfficeOpenConfigSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/TourOfficeOpenConfigSection.tsx